export default __webpack_public_path__ + "static/media/aion-wing-overlay.60d1fe35.png";